import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import UserMessage from "../atoms/list-items/UserMessage.jsx";
import BotMessage from "../atoms/list-items/BotMessage.jsx";
import SelectionMessage from "../atoms/list-items/SelectionMessage.jsx";
import AgentMessage from "../atoms/list-items/AgentMessage.jsx";
import {
    PLACEHOLDER_ANSWER,
    PLACEHOLDER_QUESTION,
} from "../../../constants.js";

export default function MessagesContainer() {
    const messageContainer = useRef();
    const messagesArchived = useSelector(
        (state) => state.messages.messagesArchived
    );
    const messages = useSelector((state) => state.messages.messages);
    const isEnd = useSelector((state) => state.messages.isEnd);

    useEffect(() => {
        messageContainer.current.scrollTop =
            messageContainer.current.scrollHeight;
    }, [messages, isEnd]);

    const handleMessagesScroll = (event) => {
        event.stopPropagation();
    };

    return (
        <ul
            ref={messageContainer}
            className="messages"
            onWheel={handleMessagesScroll}
        >
            {[...messagesArchived, ...messages].map((message, index) => {
                if (message.user_id === "system") {
                    return (
                        <li className="system" key={index}>
                            {" "}
                            {message.content}{" "}
                        </li>
                    );
                } else if (
                    message.user_id === "user" &&
                    message.content_type === "normal" &&
                    message.content !== PLACEHOLDER_QUESTION
                ) {
                    return <UserMessage message={message} key={index} />;
                } else if (
                    message.user_id === "bot" &&
                    message.content_type === "normal" &&
                    message.content !== PLACEHOLDER_ANSWER
                ) {
                    return <BotMessage message={message} key={index} />;
                } else if (
                    message.user_id === "bot" &&
                    message.content_type === "selection"
                ) {
                    return <SelectionMessage message={message} key={index} />;
                } else if (
                    message.user_id === "agent" &&
                    message.content_type === "normal"
                ) {
                    return <AgentMessage message={message} key={index} />;
                }
            })}
        </ul>
    );
}
